import Atc from '../../../../Lib/ATC';

import authLogin from './login';
import authStartup from './startup';
import authSignup from './signup';
import authLogout from './logout';
import authForgetPassword from './forgetPassword';
import authVerifyForgetPassword from './verifyForgetPassword';
import authResetPassword from './resetPassword';
import authResetPasswordConfirmation from './resetPasswordConfirmation';

export const ErrorTypes = Atc.UseCases.Types.JemisysErrorTypes.AuthErrorTypes;

export default {
    authLogin,
    authStartup,
    authSignup,
    authLogout,
    authForgetPassword,
    authVerifyForgetPassword,
    authResetPassword,
    authResetPasswordConfirmation,
};
